export default {
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    }
  },
  methods: {
    /**
     * @function loadStitches
     * Functions to gets stitches object
     */
    loadStitches(size) {
      const promises = [];
      const { s3ModelsBucket } = this.$store.state.endPoints.customizer;
      const components = this.pdm.components;
      const defaultSize = this.$store.state.utils.bucketSizes[this.pdm.ugcDefaultSize];
      const sizeToLoad = size ? size : defaultSize;
      const modelSKU = this.pdm.parent_model ? this.pdm.parent_model : this.pdm.sku;
      const stitchesURL = `${s3ModelsBucket}gltf_models/${modelSKU}/${sizeToLoad}/stitches/`;
      Object.keys(components).forEach(name =>{
        if(components[name].stitches) {
          const stitches = components[name].stitches;
          promises.push(
            this.$model3D.loadObject(this.$store.getters["utils/addCacheBusting"](`${stitchesURL}${stitches.url}`)).then(geometry => {
              const mesh = geometry.getObjectByName(`${name}_stitches`);
              this.$model3D.modelObj.add(geometry.children[0].children[0]);
              this.$model3D.sceneHelpers.updateMaterialOptions({ mesh, options: this.pdm.components[name].stitches.material_options.mesh_options});
            })
          );
        }
      });

      return Promise.all(promises);
    }
  }
};
